import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-custom ml-4" }
const _hoisted_2 = { class: "apartment__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CallModeForm = _resolveComponent("CallModeForm")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_CallModeForm, {
        disabled: _ctx.disableCallModeChange,
        class: "mt-4",
        ref: "callModeForm",
        infoPlant: _ctx.editedInfoPlant,
        adminView: _ctx.adminView,
        sortingEnabled: true
      }, null, 8, ["disabled", "infoPlant", "adminView"])
    ]),
    _createVNode("footer", _hoisted_2, [
      _createVNode(_component_Button, {
        class: "p-button-rounded p-button-raised p-button--m",
        disabled: _ctx.saveDisabled,
        onClick: _ctx.handleChangeCallMode
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Save")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ], 64))
}